// @ts-nocheck
import { createStore, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { loadingBarMiddleware } from 'react-redux-loading-bar';

import reducers from '../reducers/index';

const store: Store = createStore(reducers, {}, applyMiddleware(thunk, promiseMiddleware(), loadingBarMiddleware()));

export default store;
